import React, { useEffect, useState } from 'react';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/Attendance/form';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_attendanceDetails, v3_attendanceSubmit, v3_delete_attendance } from '../../actions/v3/attendance';
import { toast } from 'react-toastify';
import constant from '../../constant';
import { getLoggedInUserRoleId } from '../../utils';
import { hasPermission } from '../../utils/hasPermission';
import { Redirect } from 'react-router-dom';

const errorMessage = (error, fallback) => typeof error === 'string' ? error : error?.message || fallback;

const Add = (props) => {

    const location = useLocation();
    const { project, mode, attendanceDate: initialAttendanceDate } = location.state || {};
    const projectId = project?.PROJECT_ID;

    const [data, setData] = useState(null);
    const [copiedFromDate, setCopiedFromDate] = useState('');
    const [loadedDate, setLoadedDate] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);


    // State for attendance date
    const [attendanceDate, setAttendanceDate] = useState(initialAttendanceDate || '');
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;
    const canManageAttendance = isAdmin || hasPermission(constant.actionPermission.attendanceManageRecords);
    const canEdit = canManageAttendance && projectId && attendanceDate && loadedDate === attendanceDate && !isLoading && !isSaving;

    const onSubmit = async (model) => {
        if (!canEdit) return;
        setIsSaving(true);
        try {
            const res = await v3_attendanceSubmit({ rows: model, projectId, attendanceDate });
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.attendanceProjectList.url);
            }
            else {
                toast.error(errorMessage(res.error, 'Unable to save attendance.'));
            }
        } catch (error) {
            toast.error(errorMessage(error, 'Unable to save attendance.'));
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        if (mode === 'edit') return;
        let cancelled = false;
        setData(null);
        setCopiedFromDate('');
        setLoadedDate('');
        if (!attendanceDate || !projectId) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const loadAttendance = async () => {
            try {
                const res = await v3_attendanceDetails(projectId, attendanceDate, { includePrevious: true });
                if (cancelled) return;
                if (!res.status) {
                    toast.error(errorMessage(res.error, 'Unable to load attendance.'));
                    return;
                }
                setData(res.result.rows || []);
                setCopiedFromDate(res.result.copiedFromDate || '');
                setLoadedDate(attendanceDate);
            } catch (error) {
                if (!cancelled) toast.error(errorMessage(error, 'Unable to load attendance.'));
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };
        loadAttendance();
        return () => { cancelled = true; };
    }, [attendanceDate, projectId, mode]);

    const deleteAttendance = async () => {
        if (!canEdit || !window.confirm(`Delete attendance for ${attendanceDate}? This cannot be undone.`)) return;
        setIsSaving(true);
        try {
            const res = await v3_delete_attendance(projectId, attendanceDate);
            if (res.status) {
                toast.success(res.result?.message || 'Attendance deleted.');
                setData([]);
            } else toast.error(errorMessage(res.error, 'Unable to delete attendance.'));
        } catch (error) {
            toast.error(errorMessage(error, 'Unable to delete attendance.'));
        } finally {
            setIsSaving(false);
        }
    };
    if (mode === 'edit') return <Redirect to={{
        pathname: constant.Authedcomponent.attendanceEdit.url,
        state: { ...location.state },
    }} />;

    return (
        <Layout title="Attendance">

            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body"></div>
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-10">
                                    <div className="text-center">
                                        <h4>{project?.PROJECT_NAME} Project Time Sheet</h4>

                                    </div>
                                </div>
                                <div className="col-md-2 text-end">
                                    {/* Date field */}
                                    <input
                                        type="date"
                                        aria-label="Attendance date"
                                        className="form-control"
                                        disabled={isSaving || !projectId}
                                        value={attendanceDate}
                                        onChange={(e) => setAttendanceDate(e.target.value)}
                                    />
                                    {isAdmin && attendanceDate && data?.length > 0 && (
                                        <button type="button" disabled={!canEdit} className="btn btn-sm btn-outline-danger mt-2" onClick={deleteAttendance}>
                                            <i className="bx bx-trash" /> Delete attendance
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {!projectId && <p role="alert">Select a project from Manage Attendance to continue.</p>}
                        {!attendanceDate && <p>Select an attendance date to load or update its records.</p>}
                        {isLoading && <p role="status">Loading attendance...</p>}
                        {copiedFromDate && <p role="status" className="mx-3">
                            Showing the latest earlier attendance from {copiedFromDate} as a starting copy. Changes will be saved for {attendanceDate}.
                        </p>}
                        <Form
                            buttonName={isSaving ? 'Saving...' : 'Submit attendance'}
                            onSubmit={onSubmit}
                            data={data}
                            disabled={!canEdit}
                        />


                    </div>
                </div>
            </div >

        </Layout>
    );
};

export default Add;
